
import Vue from "vue";
//import HeroBar from "@/components/HeroBar.vue";
import { AuthService } from "@/services/AuthService";
export default Vue.extend({
  name: "RequestAccess",
  components: {
    // HeroBar
  },
  data() {
    return {
      authService: new AuthService()
    };
  },
  methods: {
    ssoLogin() {
      this.authService.login({});
    }
  }
});
